import * as guestConstant from './constants'
const initialState = {

  listNV: [],
  listKH: [],
  list: [],
  item: {},
  listEXP: [],
  type: guestConstant.GUEST_REPORT_LIST_INITING,
  listRequesting: false,
  requesting: false,
  successful: false,
  messages: [],
  errors: [],
  listNhomKh: []
}

const reducer = function productsReducer(state = initialState, action) {
  switch (action.type) {
    case guestConstant.GUEST_REPORT_NVKD_REQUESTING:
      return {
        type: action.type,
        requesting: false,
        successful: false,
        messages: [{
          body: 'Đang tải dữ liệu...!',
          time: new Date(),
        }],
        errors: []
      }

    case guestConstant.GUEST_REPORT_NVKD_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listNV: action.data,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case guestConstant.GUEST_REPORT_NVKD_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case guestConstant.GUEST_REPORT_KH_REQUESTING:
      return {
        type: action.type,
        requesting: false,
        successful: false,
        messages: [{
          body: 'Đang tải dữ liệu...!',
          time: new Date(),
        }],
        errors: []
      }

    case guestConstant.GUEST_REPORT_KH_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listKH: action.data,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case guestConstant.GUEST_REPORT_KH_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case guestConstant.GUEST_REPORT_LIST_REQUESTING:
      return {
        type: action.type,
        listRequesting: true,
        requesting: false,
        successful: false,
        messages: [{
          body: 'Đanh lấy dữ liệu...!',
          time: new Date(),
        }],
        errors: [],
      }

    case guestConstant.GUEST_REPORT_LIST_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: action.data ? action.data.records : [],
        item: action.data || {},
        listRequesting: false,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case guestConstant.GUEST_REPORT_LIST_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: false,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case guestConstant.GUEST_REPORT_EXPORT_XLS_REQUESTING:
      return {
        ...state,
        type: action.type,
        listRequesting: true,
        requesting: false,
        successful: false,
        messages: [{
          body: 'Đang tải dữ liệu...!',
          time: new Date(),
        }],
        errors: [],
        formData: action.payload,
        callback: action.callback,
      }

    case guestConstant.GUEST_REPORT_EXPORT_XLS_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listEXP: action.data,
        listRequesting: false,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case guestConstant.GUEST_REPORT_EXPORT_XLS_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: false,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case guestConstant.GUEST_REPORT_NHOMKH_REQUESTING:
      return {
        type: action.type,
      }

    case guestConstant.GUEST_REPORT_NHOMKH_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listNhomKh: action.data.records || [],
      }

    case guestConstant.GUEST_REPORT_NHOMKH_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
      }

    case guestConstant.GUEST_REPORT_KH_BY_NHOM_REQUESTING:
      return {
        type: action.type,
      }

    case guestConstant.GUEST_REPORT_KH_BY_NHOM_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listKH: action.data || [],
      }

    case guestConstant.GUEST_REPORT_KH_BY_NHOM_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
      }
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/views/Reports/GuestReport/reducer.js